// Angular
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
// Local services
import { ClienteService } from '../../services/cliente.service';
// 3rd libraries
import swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
// Common functions
import { CommonFunctions } from '../../utils/common-functions';
@Component({
  selector: 'app-gestiones-ofertas-preca-tc',
  templateUrl: './gestiones-ofertas-preca-tc.component.html',
  styleUrls: ['./gestiones-ofertas-preca-tc.component.scss']
})
export class GestionesOfertasPrecaTcComponent implements OnInit {
  // Decorations
  @Output() selecttab = new EventEmitter<number>();
  @Output() setDataCliente = new EventEmitter<any>();
  @Input() clienteserviceParam: ClienteService;
    // Formatters
    formatterDecimal = new Intl.NumberFormat('es-GT', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
      style: 'decimal',
    });
    // Bindings
    commonFunctions = CommonFunctions;
    ofertasComerciales=[]
    ofertaseleccionada=0
  constructor(private ngxUiLoaderService: NgxUiLoaderService,) { 
    this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
    setTimeout(() => {
      this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
      
      // Agrupar ofertas por categoría
      const ofertasPorCategoria = this.clienteserviceParam.ofertasComerciales.ofertaComercial.reduce((result, oferta) => {
        if (!result[oferta.nombreCategoria]) {
          result[oferta.nombreCategoria] = [];
        }
        result[oferta.nombreCategoria].push(oferta);
        return result;
      }, {});

      Object.keys(ofertasPorCategoria).forEach(categoria => {
        const ofertasCategoria = ofertasPorCategoria[categoria];
        
        const ofertasRojas = ofertasCategoria.filter(oferta => oferta.color === 'ROJO');
        const ofertasVerdes = ofertasCategoria.filter(oferta => oferta.color === 'VERDE');
        
        let ofertaSeleccionada;
        
        if (ofertasRojas.length > 0 && ofertasVerdes.length > 0) {
          // Si hay ofertas de ambos colores, seleccionar la VERDE con mayor limiteSuperior
          ofertaSeleccionada = ofertasVerdes.reduce((max, oferta) => 
            oferta.limiteSuperior > max.limiteSuperior ? oferta : max
          );
        } else if (ofertasRojas.length > 0) {
          // Si solo hay ofertas ROJAS, seleccionar la de mayor limiteSuperior
          ofertaSeleccionada = ofertasRojas.reduce((max, oferta) => 
            oferta.limiteSuperior > max.limiteSuperior ? oferta : max
          );
        } else if (ofertasVerdes.length > 0) {
          // Si solo hay ofertas VERDES, seleccionar la de mayor limiteSuperior
          ofertaSeleccionada = ofertasVerdes.reduce((max, oferta) => 
            oferta.limiteSuperior > max.limiteSuperior ? oferta : max
          );
        }
        
        if (ofertaSeleccionada) {
          this.ofertasComerciales.push(ofertaSeleccionada);
        }
      });

    }, 1000);
  }

  ngOnInit(): void {
  }
  goToSeleccion() {
    this.clienteserviceParam.ofertaseleccionada=this.ofertaseleccionada
    if (this.clienteserviceParam.ofertasComerciales.ofertaComercial[this.ofertaseleccionada].color == "ROJO") {
      this.clienteserviceParam.setReglaRechazoTc()
    }
    this.selecttab.emit(11)
  }
  goBack() {
    this.clienteserviceParam.ofertaseleccionada =null
    this.selecttab.emit(15)
  }
  selectOferta(index) {
    this.ofertaseleccionada = index;
  }
}
